module.exports = __webpack_public_path__ + "img/logo.1e302fc9.png";